import * as React from 'react';
import { EMPTY_TEXT } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { copyAsAttachmentInfo } from '../utilities';
export const useIdentifyAsGroupSelection = ({ countryCode, groupOptions = [], initialGroup, isOpen = false, tempAttachmentInfo = [], selectedAttachmentIds = [], vinOption }) => {
    const translateFn = TranslationService.translate;
    const [prevIsOpen, setPrevIsOpen] = React.useState(isOpen);
    const selectedCopyAttachment = React.useMemo(() => copyAsAttachmentInfo.getCopyAsEligibleAttachment(tempAttachmentInfo, selectedAttachmentIds), [tempAttachmentInfo, selectedAttachmentIds]);
    const copyAsContentTypes = React.useMemo(() => copyAsAttachmentInfo.getMissingMandatoryCopyAsContentTypes(tempAttachmentInfo, vinOption), [tempAttachmentInfo, vinOption]);
    const isCopyAsDisabled = !selectedCopyAttachment || copyAsContentTypes.length === 0;
    const copyAsGroupOptions = React.useMemo(() => copyAsContentTypes.map((contentType) => ({
        label: translateFn(copyAsAttachmentInfo.getCopyAsOptionLabel(contentType, countryCode)),
        value: contentType
    })), [copyAsContentTypes, countryCode, translateFn]);
    const getValidatedInitialGroup = React.useCallback(() => {
        if (!initialGroup)
            return EMPTY_TEXT;
        const isInGroupOptions = groupOptions.some(option => option.value === initialGroup);
        return isInGroupOptions ? initialGroup : EMPTY_TEXT;
    }, [initialGroup, groupOptions]);
    const [selectedGroup, setSelectedGroup] = React.useState(isOpen ? getValidatedInitialGroup() : EMPTY_TEXT);
    React.useEffect(() => {
        // Modal just opened or is open on first mount
        if (isOpen && !prevIsOpen) {
            setSelectedGroup(getValidatedInitialGroup());
        }
        // Modal just closed
        if (!isOpen && prevIsOpen) {
            setSelectedGroup(EMPTY_TEXT);
        }
        setPrevIsOpen(isOpen);
    }, [isOpen, getValidatedInitialGroup]);
    // Only reset selectedGroup if it becomes unavailable while modal is open
    React.useEffect(() => {
        if (!isOpen)
            return;
        const isCurrentValid = selectedGroup === EMPTY_TEXT || groupOptions.some(option => option.value === selectedGroup);
        if (!isCurrentValid) {
            setSelectedGroup(getValidatedInitialGroup());
        }
    }, [isOpen, selectedGroup, groupOptions, getValidatedInitialGroup]);
    return {
        copyAsGroupOptions,
        isCopyAsDisabled,
        selectedGroup,
        selectedCopyAttachment,
        setSelectedGroup
    };
};
//# sourceMappingURL=useIdentifyAsGroupSelection.js.map